import { create } from "zustand";

interface UIState {
  selectedTreeId: string | null;
  selectedBranch: string;
  sidebarOpen: boolean;
  sidebarCollapsed: boolean;
  searchQuery: string;
  darkMode: boolean;

  setSelectedTreeId: (id: string | null) => void;
  setSelectedBranch: (branch: string) => void;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebarCollapsed: () => void;
  setSearchQuery: (query: string) => void;
  setDarkMode: (dark: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  selectedTreeId: null,
  selectedBranch: "all",
  sidebarOpen: typeof window !== 'undefined' ? window.innerWidth >= 640 : true,
  sidebarCollapsed: false,
  searchQuery: "",
  darkMode: typeof window !== 'undefined'
    ? localStorage.getItem('darkMode') === 'true'
    : false,

  setSelectedTreeId: (id) => set({ selectedTreeId: id }),
  setSelectedBranch: (branch) => set({ selectedBranch: branch }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebarCollapsed: () =>
    set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSearchQuery: (query) => set({ searchQuery: query }),
  setDarkMode: (dark) => {
    localStorage.setItem('darkMode', String(dark));
    if (dark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    set({ darkMode: dark });
  },
}));
